import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Form, Button, Card, CardBody, Alert } from "reactstrap";
import Select1 from 'react-select';

/**
 * 
 * @param {*} planes lista de planes 
 * @returns Array con planes formateado para la lista
 */
function obtenerValores(planes) {

    var auxPrincipal = [];

    planes[0].valoresCobertura.forEach(cobertura => {
        var auxSecundario = []

        planes.forEach(plan => {

            plan.valoresCobertura.forEach(valor => {

                if (cobertura.titulo == valor.titulo) {
                    auxSecundario.push(valor)

                }

            });

        });
        auxPrincipal.push(auxSecundario)

    })


    return auxPrincipal;





}


const Diferidos = (props) => {

    const { datosBancos, maximoMeses, setCuotasSeleccionadasPrincipal, setBancoSeleccionadoPrincipal } = props;

    const [bancoSeleccionado, setBancoSeleccionado] = useState(listSlct1(datosBancos)[0])
    const [diferidos, serDiferidos] = useState(1)
    const [cuotaSeleccionada, setCuotaSeleccionada] = useState({
        value: 1,
        label: '1 mes (Pago corriente)'
    })
    const [coutas, setCuotas] = useState(1)
    const [codigoBanco, setCodigoBanco] = useState(listSlct1(datosBancos)[0].value)
    const [arrayCuotas, setArrayCuotas] = useState(listSlct1Cuotas(datosBancos[0].cuotas, maximoMeses))

    useEffect(() => {
        setBancoSeleccionadoPrincipal(codigoBanco)
    }, codigoBanco)

   



    const handleChangeBanco = (valor) => {

        const diferidos = datosBancos.find(banco => banco.id == valor.value).cuotas

        console.log('diferiodos: ', diferidos)
        setBancoSeleccionado(valor)
        setCuotaSeleccionada(listSlct1Cuotas(diferidos, maximoMeses)[0])

        setCodigoBanco(valor.value)
        setBancoSeleccionadoPrincipal(valor.value)
        setCuotasSeleccionadasPrincipal(1)
        setArrayCuotas(listSlct1Cuotas(diferidos, maximoMeses))
        setCuotas(1)

        console.log(cuotaSeleccionada)

    }


    const handleChangeCuotas = (valor) => {

        setCuotaSeleccionada(valor)
        setCuotasSeleccionadasPrincipal(valor.value)
        setCuotas(valor.value)

    }



    return (
        <Card className="flex-row" style={{ marginBottom: 300 }}>
            <CardBody>
                <h4 style={{ fontWeight: "bold" }}>Diferido</h4>
                <p />

                <Row>


                    <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Seleccione el banco emisor de su tarjeta</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                        <Select1
                            options={listSlct1(datosBancos)}
                            value={bancoSeleccionado}

                            onChange={
                                (value, e) => {

                                    handleChangeBanco(value)
                                }
                            }


                        />
                    </Col>
                </Row>

                <Row>


                    <Col lg={6} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Seleccione los meses a diferir</h5>

                        {arrayCuotas && arrayCuotas.length == 1 &&
                            <Alert color="warning">

                                <strong>
                                    {
                                        "Su banco permite el pago únicamente en corriente"
                                    }
                                </strong>

                            </Alert>
                        }

                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                        <Select1
                            value={cuotaSeleccionada}
                            options={arrayCuotas}
                            searchable={false}
                            onChange={
                                (value, e) => {
                                    handleChangeCuotas(value)
                                }
                            }
                        />
                    </Col>
                </Row>


            </CardBody>

        </Card>

    );



};

/**
 * 
 * @param {*} list lista inicial
 * @returns  Lista formateada para utilizar en Select1
 */
const listSlct1 = (list) => {
    console.log('list', list)
    const formatList = []
    for (const idx in list) {

        formatList.push({
            value: list[idx]['id'],
            label: list[idx]['nombre']
        })
    }

    // return
    return formatList
}

/**
  * 
  * @param {*} list lista inicial
  * @returns  Lista formateada para utilizar en Select1
  */
const listSlct1Cuotas = (list, maximoMeses) => {



    console.log('list', list)
    const formatList = []

    list.forEach(element => {

        if (element <= maximoMeses) {
            formatList.push({
                value: element,
                label: element == 1 ? '1 mes (Pago corriente)' : element + ' meses'
            })
        }

    });


    // return
    return formatList
}





export default Diferidos;
